/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import { CustomCardGrid } from "../../../../components/CustomCardGrid";
import { useTranslation } from "react-i18next";
import { gender } from "../../../../enums/genderEnum";
import { statusBorderColor, statusColor, statusFontColor } from "../../../../enums/statusColorEnum";
import { status } from "../../../../enums/statusEnum";
import { EMPTY_VALUES } from "../../../../Apis/functions";
import userDefault from '../../../../assets/ImagesDefaults/ic-person-v2.svg';
import CustomTooltip from '../../../../components/CustomTooltip';
import {
    EmailSubsectionChip, IconCalendarPaid,
    IconGender,
    IconIdentificationCard,
    PhoneSubsectionChip
} from '../../../../components/buttons/IconButtons';
import RowCardText from '../../../../components/RowCardText';

const EmployeeCardGrid = ({ elementDetails }) => {
    const { t } = useTranslation();
    return (
        <>
            <CustomCardGrid
                classNamePanelGrid=''
                height='border-full-shades-200 border-radius-16px'
                itemId={elementDetails?.id}
                statusColor={statusColor[elementDetails?.user?.statusId || elementDetails?.user?.status?.id]}
                fontColor={statusFontColor[elementDetails?.user?.statusId || elementDetails?.user?.status?.id]}
                borderColor={statusBorderColor[elementDetails?.user?.statusId || elementDetails?.user?.status?.id]}
                statusName={t(status[elementDetails?.user?.statusId || elementDetails?.user?.status?.id]) || EMPTY_VALUES.DEFAULT}
                chipVariant={'large'}
                isSquareImg={false}
                isCheckboxShow={false}
                headClass={'minh-144px'}
                srcImage={elementDetails?.user?.selfie ? `data:image/png;base64,${elementDetails?.user?.selfie}` : userDefault}
                backgroundImage={
                    elementDetails?.user?.selfie != null ? `data:image/png;base64,${elementDetails?.user?.selfie}` : ''
                }
            >
                <div className="px-2">
                    <div className='d-flex flex-column align-items-center mb-4'>
                        <CustomTooltip
                            text={`${elementDetails?.user?.name} ${elementDetails?.user?.lastName ?? ''} ${elementDetails?.user?.secondLastName ?? ''}`}
                            classes={`ibl-h3 ibl-font-w-600`}
                            showIfTruncated={true}
                            tooltipClasses={'p-0'}
                        />
                    </div>
                    <div className='border-bottom-shades-300 mb-3' />


                    <div className='d-flex align-items-center my-2'>
                        <EmailSubsectionChip className='w-20px h-20px' />
                        <RowCardText
                            className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                            classNameValue='fs-14px ibl-font-w-300'
                            classNameTitle='fs-14px ibl-font-w-600'
                            title={t('email')}
                            value={
                                <CustomTooltip
                                    text={elementDetails?.user?.email || EMPTY_VALUES.DEFAULT}
                                    placement='bottom'
                                    classes='text-truncate'
                                >
                                    <span className='text-truncate d-inline-block'>
                                        {elementDetails?.user?.email || EMPTY_VALUES.DEFAULT}
                                    </span>
                                </CustomTooltip>
                            }
                        />
                    </div>
                    <div className='d-flex align-items-center my-2'>
                        <PhoneSubsectionChip className='w-20px h-20px' />
                        <RowCardText
                            className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                            classNameValue='fs-14px ibl-font-w-300'
                            classNameTitle='fs-14px ibl-font-w-600'
                            title={t('telephone')}
                            value={
                                <CustomTooltip
                                    text={elementDetails?.user?.phoneNumber || EMPTY_VALUES.DEFAULT}
                                    placement='bottom'
                                    classes='text-truncate'
                                >
                                    <span className='text-truncate d-inline-block'>
                                        {elementDetails?.user?.phoneNumber || EMPTY_VALUES.DEFAULT}
                                    </span>
                                </CustomTooltip>
                            }
                        />
                    </div>
                    <div className='d-flex align-items-center my-2'>
                        <IconGender className='w-20px h-20px' />
                        <RowCardText
                            className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                            classNameValue='fs-14px ibl-font-w-300'
                            classNameTitle='fs-14px ibl-font-w-600'
                            title={t('gender')}
                            value={
                                <CustomTooltip
                                    text={t(gender[elementDetails?.user?.genderId || elementDetails?.genderId]) || EMPTY_VALUES.DEFAULT}
                                    placement='bottom'
                                    classes='text-truncate'
                                >
                                    <span className='text-truncate d-inline-block'>
                                        {t(gender[elementDetails?.user?.genderId || elementDetails?.genderId]) || EMPTY_VALUES.DEFAULT}
                                    </span>
                                </CustomTooltip>
                            }
                        />
                    </div>
                    <div className='d-flex align-items-center my-2'>
                        <IconIdentificationCard className='w-20px h-20px' />
                        <RowCardText
                            className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                            classNameValue='fs-14px ibl-font-w-300'
                            classNameTitle='fs-14px ibl-font-w-600'
                            title={t('document_id')}
                            value={
                                <CustomTooltip
                                    text={elementDetails?.user?.documentId || EMPTY_VALUES.DEFAULT}
                                    placement='bottom'
                                    classes='text-truncate'
                                >
                                    <span className='text-truncate d-inline-block'>
                                        {elementDetails?.user?.documentId || EMPTY_VALUES.DEFAULT}
                                    </span>
                                </CustomTooltip>
                            }
                        />
                    </div>
                    <div className='d-flex align-items-center my-2'>
                        <IconCalendarPaid className='w-20px h-20px' />
                        <RowCardText
                            className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                            classNameValue='fs-14px ibl-font-w-300'
                            classNameTitle='fs-14px ibl-font-w-600'
                            title={t('dob')}
                            value={
                                <CustomTooltip
                                    text={elementDetails?.user?.dob || EMPTY_VALUES.DEFAULT}
                                    placement='bottom'
                                    classes='text-truncate'
                                >
                                    <span className='text-truncate d-inline-block'>
                                        {elementDetails?.user?.dob || EMPTY_VALUES.DEFAULT}
                                    </span>
                                </CustomTooltip>
                            }
                        />
                    </div>
                </div>
            </CustomCardGrid>
        </>
    );
};

export default EmployeeCardGrid;
